// Catherine' Shiatsu — content data
// Keeps original Shiatsu educational content (enriched) and integrates
// Catherine SAC-EPEE's personal information from the brief.

export const siteData = {
  brand: {
    name: "Catherine' Shiatsu",
    subtitle: "Détente · Bien-être",
  },
  contact: {
    fullName: "Catherine SAC-EPEE",
    role: "Praticienne en Shiatsu",
    phone: "06 61 16 74 11",
    phoneHref: "tel:+33661167411",
    email: "catherine.sacepee@gmail.com",
    instagram: "catherine_shiatsu",
    instagramUrl: "https://www.instagram.com/catherine_shiatsu/",
    facebookUrl: "https://www.facebook.com/profile.php?id=61582765151729",
    address: {
      line1: "Cabinet à La Ciotat (13)",
      line2: "",
      metro: "Interventions à La Ciotat, Aubagne, Aix, Marseille et Toulon",
    },
    siret: "SIRET 829 148 527 00023",
    entity: "EI Catherine SAC-EPEE",
    mediation:
      "Entreprise affiliée au dispositif de médiation de la consommation de la société Médiation Professionnelle.",
  },
  images: {
    hero: "https://customer-assets.emergentagent.com/job_layout-109/artifacts/jrls601z_IMG-20240916-WA0002.jpg",
    acupuncture: "https://customer-assets.emergentagent.com/job_layout-109/artifacts/grdonrow_image.png",
    seance1: "https://customer-assets.emergentagent.com/job_layout-109/artifacts/nmhl3s7f_IMG-20240916-WA0010%281%29.jpg",
    seance2: "https://customer-assets.emergentagent.com/job_layout-109/artifacts/kl2dzzv4_21194.jpg",
    seance3: "https://customer-assets.emergentagent.com/job_layout-109/artifacts/o6qijess_21207.jpg",
    portrait: "https://customer-assets.emergentagent.com/job_layout-109/artifacts/3c6j0mzw_IMG-20240916-WA0008.jpg",
    zen1: "https://images.unsplash.com/photo-1570276095143-a627b6514b1d?w=1200&q=80",
    zen2: "https://images.unsplash.com/photo-1741709501868-362398b86ff2?w=1200&q=80",
    zen3: "https://images.unsplash.com/photo-1621554258209-a4a4305e29e5?w=1200&q=80",
    zen4: "https://images.unsplash.com/photo-1611934180042-da791b4091e7?w=1200&q=80",
  },
  // Pathologies / benefits the Shiatsu addresses (adapted to Catherine's flyer)
  pathologies: [
    {
      title: "Stress & Anxiété",
      description:
        "Relâchement des tensions nerveuses, meilleure gestion du stress, stabilité émotionnelle.",
    },
    {
      title: "Troubles du sommeil",
      description:
        "Favorise un sommeil réparateur, apaise l'agitation mentale et les insomnies.",
    },
    {
      title: "Fatigue & Vitalité",
      description:
        "Recharge l'énergie vitale, réduit la fatigue et stimule la récupération.",
    },
    {
      title: "Douleurs",
      description:
        "Douleurs articulaires, musculaires, menstruelles, chroniques et tensions diverses.",
    },
    {
      title: "Circulation & Posture",
      description:
        "Amélioration de la circulation sanguine, de la posture et diminution des Troubles Musculo-Squelettiques.",
    },
    {
      title: "Concentration & Créativité",
      description:
        "Clarté mentale, meilleure concentration et retour d'une créativité sereine.",
    },
    {
      title: "Défenses naturelles",
      description:
        "Stimulation du système immunitaire et renforcement des défenses naturelles.",
    },
    {
      title: "Harmonie corps-esprit",
      description:
        "Détente profonde, sérénité durable et rééquilibrage énergétique global.",
    },
  ],
  tarifs: {
    cabinet: [
      { label: "Soin découverte (30 min)", price: "30 €" },
      { label: "Soin complet (1 h 15)", price: "70 €" },
      { label: "Forfait 5 séances", price: "300 €" },
    ],
    entreprise: [
      { label: "Demi-journée", price: "6 à 7 soins" },
      { label: "Journée", price: "12 soins" },
    ],
    remboursement:
      "De nombreuses mutuelles remboursent actuellement le Shiatsu (nombre de séances ou montant annuel).",
  },
  quotes: {
    rohn: {
      text:
        "Prends soin de ton corps, c’est le seul endroit permanent dans lequel tu es amené à vivre.",
      author: "E.J. Rohn",
    },
    bouheret: {
      text:
        "Puissant, précis et apaisant, le Shiatsu est une invitation à relâcher les tensions et à retrouver une énergie fluide.",
      author: "Catherine' Shiatsu",
    },
    chengManChing: {
      text:
        "Tout doit rester connecté. Lorsqu’une partie du corps est en mouvement tout doit être en mouvement, si une partie du corps est immobile, tout doit être immobile.",
      author: "Cheng Man-Ch’ing (maître de taiji)",
    },
  },
};
